const ROLE_DEFINITIONS = Object.freeze({
  admin: {
    label: 'Admin',
    description: 'Full workspace access including user management and configuration.',
    permissions: ['users.manage', 'workspace.manage', 'content.view', 'content.create', 'content.update', 'content.manage', 'attachments.manage', 'reports.view', 'exports.create'],
  },
  manager: {
    label: 'Manager',
    description: 'Can manage strategy content, attachments, and reports without changing workspace users.',
    permissions: ['content.view', 'content.create', 'content.update', 'content.manage', 'attachments.manage', 'reports.view', 'exports.create'],
  },
  member: {
    label: 'Member',
    description: 'Can create and update strategy content and attachments.',
    permissions: ['content.view', 'content.create', 'content.update', 'attachments.manage', 'reports.view'],
  },
  viewer: {
    label: 'Viewer',
    description: 'Can view shared strategy content and reports.',
    permissions: ['content.view', 'reports.view'],
  },
});

const ROLE_ORDER = Object.freeze(['admin', 'manager', 'member', 'viewer']);
const DEFAULT_ROLE = 'member';

function getRoleDefinition(role) {
  return ROLE_DEFINITIONS[role] || null;
}

function getPermissionsForRole(role) {
  return getRoleDefinition(role)?.permissions || [];
}

function hasPermission(user, permission) {
  return Boolean(user?.permissions?.includes(permission));
}

function getRoleLabel(role) {
  return getRoleDefinition(role)?.label || 'Unknown';
}

function isValidRole(role) {
  return Boolean(getRoleDefinition(role));
}

module.exports = {
  DEFAULT_ROLE,
  ROLE_DEFINITIONS,
  ROLE_ORDER,
  getPermissionsForRole,
  getRoleDefinition,
  getRoleLabel,
  hasPermission,
  isValidRole,
};
